import {MatDialog, MatDialogConfig, MatDialogRef} from "@angular/material/dialog";

import {Injectable} from "@angular/core";
import {HeaderDataService} from "./header_data.service";
import {DateTimeInstanceService} from "./date-time-instance.service";
import {IDateTimePeriod} from "../_typing/date-time-period";
import {ChartDialog} from "../charts/chart-dialog/chart-dialog.component";
import {concatMap, filter, takeUntil, tap} from "rxjs/operators";
import {fromEvent} from "rxjs";

@Injectable({providedIn: 'root'})
export class ChartDialogService {
    public chartDialogRef: MatDialogRef<ChartDialog>;
    private showingCommentDrawer: boolean = false;

     constructor(public dialog: MatDialog,
                private headerData: HeaderDataService,
                private dateInst: DateTimeInstanceService) {
    }

    resizeWithCommentDrawerSubscribe(): void {
        this.headerData.showingCommentPanel.pipe(
            takeUntil(this.chartDialogRef.afterClosed()),
            // Extra check, don't subscribe unless chart_dialog is open
            filter(value => this.chartDialogRef !== undefined)
        ).subscribe(value => {
            this.showingCommentDrawer = value.toggle;
            if (value.toggle === true && this.chartDialogRef) {
                this.chartDialogRef.updatePosition({left: '10px'});
                this.chartDialogRef.updateSize('65%');
            } else if (this.chartDialogRef) {
                this.chartDialogRef.updatePosition({left: undefined});
                this.chartDialogRef.updateSize('1200px');
            }
        });
    }

    openChartDialog(series_name: string, dtp: IDateTimePeriod = this.dateInst.dtp) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.data = {config: {series_name: series_name, dtp: dtp}};
        dialogConfig.hasBackdrop = false;
        dialogConfig.disableClose = false;
        dialogConfig.panelClass = 'default-chart-dialog';
        this.chartDialogRef = this.dialog.open(ChartDialog, dialogConfig);

        // Since hasBackdrop can't be changed once dialog is open...
        this.chartDialogRef.afterOpened().pipe(
            concatMap(() => {
                return fromEvent(document, 'click').pipe(
                    tap(value => {
                        let target: Element = value.target as Element;
                        if (this.showingCommentDrawer || target.closest('mat-dialog-container') !== null
                            || target.closest('.cdk-overlay-container') !== null
                            || ['close-comments-button', 'close-comments-button-icon'].includes(target.id)) {
                            return;
                        }

                        this.chartDialogRef.close();
                    }));
            }),
            takeUntil(this.chartDialogRef.afterClosed())).subscribe();

        this.resizeWithCommentDrawerSubscribe();
        return this.chartDialogRef;
    }
}
